import { useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { BenefitsHealthcarePageDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterHealthcareBeneficiariesPage = ({ closePath }: { closePath: string }) => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()
  const navigate = useNavigate()
  const { data, error } = useQuery(BenefitsHealthcarePageDocument, {
    fetchPolicy: 'network-only',
    variables: { companyId: company.id },
  })

  const canImportResources = data?.universalImporter?._policies.importResources.can

  const onClose = () => {
    navigate(closePath)
  }

  if (data && (error || !canImportResources)) {
    navigate(closePath)
    return null
  }

  if (!data || !canImportResources) {
    return null
  }

  return (
    <Modal
      illustration="table-file"
      title={i18n.t('benefits.healthcare.management.importer.title')}
      onClose={onClose}
      disableFocusTrap
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
        </Box>
      }
    >
      <NuvoImporter
        importType="healthcare_beneficiaries_importer"
        locale={locale}
        companyId={company.id}
      />
    </Modal>
  )
}

export default UniversalImporterHealthcareBeneficiariesPage
